import { useForm, useWatch } from 'react-hook-form';
import { useUpdateEffect } from 'react-use';

import { CustomFieldTextAttribute } from 'apis/customFields';
import { BaseCustomFieldText } from 'components/customFields';

import { CustomFieldAdapterProps } from '../customFieldAdapter.types';

export function CustomFieldTextAdapter({
  attribute,
  prefix,
  value,
  name,
  onAttributeChange,
}: CustomFieldAdapterProps<CustomFieldTextAttribute, string>): JSX.Element {
  const defaultValues = { [name]: value };

  const { control } = useForm({ defaultValues });
  const formValue = useWatch({ control, name });

  useUpdateEffect(
    () => onAttributeChange(formValue),
    [formValue, onAttributeChange],
  );

  return (
    <BaseCustomFieldText
      customField={{
        attribute,
        value: { data_type: 'string', value },
      }}
      control={control}
      name={name}
      isRequired
      componentProps={{ prefix }}
    />
  );
}
